import { Profile, Task } from '../lib/types/database.types'

type TaskNotificationPayload = {
  taskId: string
  uniqueTaskId: string
  taskTitle: string
  status?: string
  priority?: string
  type?: string
  appName?: string
  dueDate?: string | null
  description?: string | null
  requestedBy?: string
}
const postNotification = async (endpoint: string, body: unknown, successLog: string, failureLog: string) => {
  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })

    const responseBody = await response.text()

    if (!response.ok) {
      console.error(failureLog, {
        endpoint,
        status: response.status,
        body: responseBody,
      })
      return false
    }

    console.log(successLog, {
      endpoint,
      status: response.status,
      body: responseBody,
    })
    return true
  } catch (error) {
    console.error(failureLog, { endpoint, error })
    return false
  }
}

export const buildTaskNotificationPayload = (task: Task): TaskNotificationPayload => ({
  taskId: task.id,
  uniqueTaskId: task.unique_task_id,
  taskTitle: task.title,
  status: task.status,
  priority: task.priority,
  type: task.type,
  appName: task.related_app,
  dueDate: task.overall_due_date,
  description: task.description,
})

export const sendTaskAssignedEmail = async (to: string, task: Task) =>
  postNotification(
    '/api/notifications/task-assigned',
    {
      to,
      task: buildTaskNotificationPayload(task),
    },
    `Task assignment email sent to ${to}`,
    'Task assignment email failed'
  )

export const sendTaskAssignedEmailIfNeeded = async (
  task: Task,
  profiles: Profile[],
  previousAssignedTo: string | null | undefined,
  previousStatus?: string | null
) => {
  const assignmentChanged = task.assigned_to !== previousAssignedTo
  const enteredNotificationStatus =
    ['pending_quote', 'in_dev_progress'].includes(task.status) && task.status !== previousStatus

  if (!task.assigned_to || (!assignmentChanged && !enteredNotificationStatus)) {
    return false
  }

  const assignedProfile = profiles.find((profile) => profile.id === task.assigned_to)

  if (!assignedProfile?.email) {
    console.warn('Task assignment email skipped: assigned user has no email.', {
      taskId: task.id,
      assignedTo: task.assigned_to,
    })
    return false
  }

  return sendTaskAssignedEmail(assignedProfile.email, task)
}
type QuoteNotificationPayload = { hours: number; pricePerHourZar: number; totalZar: number }

export const sendQuoteApprovedEmail = async (to: string, task: Task, quote: QuoteNotificationPayload) =>
  postNotification(
    '/api/notifications/quote-approved',
    { to, task: buildTaskNotificationPayload(task), quote },
    `Quote approval email sent to ${to}`,
    'Quote approval email failed'
  )

export const sendNewQuoteEmail = async (to: string, task: Task, quote: QuoteNotificationPayload) =>
  postNotification(
    '/api/notifications/quote-submitted',
    { to, task: buildTaskNotificationPayload(task), quote },
    `Quote notification sent to ${to}`,
    'Quote notification failed'
  )